module.exports = __webpack_public_path__ + "static/VerticalPush-MedballOverheadPress-f2fb93154d79cc029ff609d4ee3f2547.mp4";